/* sugar:assets/desktop-menu.js@2.0.0 */
/**
 * Desktop Menu dropdowns, for a Shopify menu and for Link blocks alike, List or Mega menu:
 * - Click mode: one dropdown open at a time, and a click outside the menu closes it.
 * - Hover mode (the Desktop Layout marks each menu with data-hover-open and keeps its <details>
 *   open; CSS shows the panel on :hover): Enter or Space on an item opens its panel for keyboard
 *   users, tabbing into a panel shows it, and leaving the menu, Escape or an outside click hides it.
 * - Escape closes the innermost open dropdown and returns focus to its item.
 * - Theme editor: selecting a block inside a dropdown opens it.
 * Everything is delegated from the document, so a section re-render needs no re-init.
 */
(function () {
  if (window.__sugarDesktopMenuInit) return;
  window.__sugarDesktopMenuInit = true;

  var NAV = '.header__inline-menu';
  var TOP = NAV + ' .list-menu--inline > li details[open]';

  function isHover(menu) {
    return !!menu && menu.hasAttribute('data-hover-open');
  }

  function topDetails(menu) {
    return menu.querySelector('details');
  }

  function setKeyboardOpen(menu, open) {
    var summary = topDetails(menu) && topDetails(menu).querySelector('summary');
    if (open) {
      menu.setAttribute('data-dm-open', '');
      menu.removeAttribute('data-dm-closed');
    } else {
      menu.removeAttribute('data-dm-open');
    }
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeOthers(except) {
    document.querySelectorAll(NAV + ' header-menu[data-dm-open]').forEach(function (menu) {
      if (menu !== except) setKeyboardOpen(menu, false);
    });
  }

  // Click mode: opening one dropdown closes the others, but never the dropdown it sits in.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (details.tagName !== 'DETAILS' || !details.open || !details.closest(NAV)) return;
      if (isHover(details.closest('header-menu'))) return;

      document.querySelectorAll(TOP).forEach(function (other) {
        if (other === details || other.contains(details)) return;
        if (isHover(other.closest('header-menu'))) return;
        other.removeAttribute('open');
      });
    },
    true
  );

  document.addEventListener('click', function (event) {
    var summary = event.target.closest(NAV + ' header-menu > details > summary');
    if (summary) {
      // Hover mode: a keyboard Enter or Space (a click with no pointer) opens the panel.
      var menu = summary.closest('header-menu');
      if (isHover(menu) && event.detail === 0) {
        var open = !menu.hasAttribute('data-dm-open');
        closeOthers(menu);
        setKeyboardOpen(menu, open);
      }
      return;
    }
    if (event.target.closest(NAV)) return;

    document.querySelectorAll(TOP).forEach(function (details) {
      if (isHover(details.closest('header-menu'))) return;
      details.removeAttribute('open');
    });
    closeOthers(null);
  });

  // Hover mode: tabbing into a panel shows it, and focus leaving the menu hides it again.
  document.addEventListener('focusin', function (event) {
    var menu = event.target.closest(NAV + ' header-menu');
    if (!isHover(menu)) return;
    if (!event.target.closest('.header__submenu')) return;
    if (!event.target.matches(':focus-visible')) return;
    closeOthers(menu);
    setKeyboardOpen(menu, true);
  });

  document.addEventListener('focusout', function (event) {
    var menu = event.target.closest(NAV + ' header-menu[data-dm-open]');
    if (!menu || (event.relatedTarget && menu.contains(event.relatedTarget))) return;
    setKeyboardOpen(menu, false);
  });

  // Hover mode: pointing at another item hides a panel the keyboard opened.
  document.addEventListener('mouseover', function (event) {
    var menu = event.target.closest && event.target.closest(NAV + ' header-menu');
    if (menu) closeOthers(menu);
  });

  // Hover mode: a panel hidden with Escape stays hidden until the pointer leaves the menu.
  document.addEventListener('mouseout', function (event) {
    var menu = event.target.closest && event.target.closest(NAV + ' header-menu[data-dm-closed]');
    if (menu && !menu.contains(event.relatedTarget)) menu.removeAttribute('data-dm-closed');
  });

  // Captured, so it runs before the theme's own Escape handler, which would close a hover menu's
  // forced-open <details> for good.
  document.addEventListener(
    'keyup',
    function (event) {
      if (event.key !== 'Escape' && event.code !== 'Escape') return;
      var details = event.target.closest && event.target.closest(NAV + ' details[open]');
      if (!details) return;
      var menu = details.closest('header-menu');
      if (!menu) return;
      event.stopPropagation();

      var summary = details.querySelector('summary');
      if (isHover(menu) && details === topDetails(menu)) {
        setKeyboardOpen(menu, false);
        if (menu.matches(':hover')) menu.setAttribute('data-dm-closed', '');
      } else {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
      if (summary) summary.focus();
    },
    true
  );

  if (window.Shopify && window.Shopify.designMode) {
    var menuOf = function (target) {
      if (!target || !target.closest) return null;
      return target.closest(NAV + ' header-menu') || (target.closest(NAV) && target.querySelector(':scope > header-menu'));
    };

    document.addEventListener('shopify:block:select', function (event) {
      var menu = menuOf(event.target);
      if (!menu) return;
      if (isHover(menu)) {
        closeOthers(menu);
        setKeyboardOpen(menu, true);
        return;
      }
      var details = event.target.closest('details') || topDetails(menu);
      while (details && menu.contains(details)) {
        details.setAttribute('open', '');
        details = details.parentElement && details.parentElement.closest('details');
      }
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var menu = menuOf(event.target);
      if (!menu) return;
      if (isHover(menu)) {
        setKeyboardOpen(menu, false);
      } else if (topDetails(menu)) {
        topDetails(menu).removeAttribute('open');
      }
    });
  }
})();
